module.exports = __webpack_public_path__ + "static/carbon-tooltip-interactive-0dde507de66761a31ec33200bc2718bc.png";